<template>
  <div-box>


    <nav-bar left-arrow :title="$t('提现') + 'DAB'" />


    <div-height height="5vw"></div-height>
    <div class="lever_box">
      <div class="lever_item">
        <img src="@/assets/img/logo.png" />
      </div>
    </div>

    <div-height height="5vw"></div-height>




    <div class="add_box" v-if="$store.getters.isLoggedIn">

      <div-height height="5vw"></div-height>

      <div class="label_box">
        <div class="label">{{ $t('提现数量') }}：</div>
        <div class="label">{{ $t('手续费') }}：{{ fee_rate }} BNB</div>
      </div>

      <div-height height="2vw"></div-height>

      <div class="border">
        <div-input>
          <van-field :border='false' clearable v-model='amount' :placeholder='$t("请输入提现数量")'>
            <template #button>
              <van-button size="small" block color="rgba(32, 197, 149, 1)" @click="amount = dab">
                {{ $t('全部') }}
              </van-button>
            </template>
          </van-field>
        </div-input>
      </div>

      <div-height height="2vw"></div-height>

      <div class="label">{{ $t('可用数量') }}：{{ dab }} DAB</div>

      <div-height height="3vw"></div-height>
      <div class="add_box_btn">
        <van-button size="small" round block color="rgba(32, 197, 149, 1)" :loading="loading" @click="save">
          {{ $t('提现') }}
        </van-button>
      </div>
    </div>

    <div class="add_box" v-else>
      <div class="tishi"> {{ $t('请先从左上角连接钱包') }}</div>
    </div>

    <div-padding padding="4vw 5vw">
      <div-flex>
        <div-flex left>
          <!-- <div-img width='4vw' height='4vw'>
            <img src="@/assets/img/zujian@2x.png">
          </div-img>
          <div-width width='1vw' />
          <div-text color='#fff' size='4vw'>{{ $t('提现说明') }}</div-text> -->
        </div-flex>

        <div @click="router('tixian01_list')" class="link_text">
          {{ $t('提现记录') }}
          <van-icon name="arrow" style="margin-left: 1.5vw;" />
        </div>
      </div-flex>


      <div-height height="5vw"></div-height>

      <!-- <div>
        <div-text color='#fff' size='4vw'>
          {{ $t('提现范围') }}：{{ dab_withdraw_min }} ~ {{ dab_withdraw_max }}
        </div-text>
        <div-text color='#fff' size='4vw'>
          {{ $t('提现时间') }}：{{ start_time }} ~ {{ end_time }}
        </div-text>
      </div> -->

    </div-padding>





  </div-box>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      dab: "",
      fee_rate: "",
      fee_address: "",
      dab_withdraw_min: "",
      dab_withdraw_max: "",
      start_time: "",
      end_time: "",
      amount: "",
      loading: false,
    }
  },
  created() {
    this.get_config()
    this.get_info()
  },
  methods: {
    opt() {
      this.up_down()
    },
    get_info() {
      this.$get({
        url: "/api/v1/member/getMemberInfo",
        data: {},
        success: (res) => {
          this.dab = res.data.dab
        },
        tip: () => { },
      })
    },
    get_config() {

      this.$get({
        url: "/api/v1/withdraw/getConfig",
        data: {},
        success: (res) => {
          this.fee_rate = res.data.fee_rate
          this.fee_address = res.data.fee_address
          this.dab_withdraw_min = res.data.dab_withdraw_min
          this.dab_withdraw_max = res.data.dab_withdraw_max
          this.start_time = res.data.start_time
          this.end_time = res.data.end_time

        },
        tip: () => { },
      })
    },
    save() {

      if (!this.amount) return this.$toast(this.$t("请输入数量"))
      if (this.loading == true) {
        return this.$toast(this.$t("请勿重复提交"))
      }
      this.$toast.loading({
        duration: 0,
        overlay: true
      })
      this.loading = true
      let that = this

      this.$post({
        url: '/api/v1/withdraw/createWithdraw',
        data: {
          type: 2,
          amount: this.amount,
        },
        success: (res) => {
          console.log('amount', res.data.amount)
          console.log('fee', res.data.fee)
          that.id = res.data.id

          if (res.data.fee * 1) {
            that.$nextTick(() => {
              console.log("1", that.address)
              that.blockFun
                .transfer("bnb", res.data.fee, that.fee_address, "ether", true)
                .then((hash) => {
                  that.pay(hash)
                }).catch((err) => {
                  that.loading = false
                  that.$toast.fail(that.$t(err.msg))
                })
            })
          } else {
            that.$toast('提现成功')
            that.get_info()
            that.amount = ''
            setTimeout(() => {
              that.loading = false
            }, 2000)
          }

        },
        tip: () => {
          this.$toast.clear()
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
      })
    },

    pay(hash) {
      this.$post({
        url: "/api/v1/withdraw/paySuccess",
        data: {
          id: this.id,
          hash: hash,
        },
        success: (res) => {
          this.$toast('提现成功')
          this.get_info()
          this.amount = ''
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
        tip: () => {
          this.$toast.clear()
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
      })
    },
  },
}
</script>
<style lang='less' scoped>
.lever_box {
  display: flex;
  align-items: center;
  justify-content: center;

  .lever_item {
    width: 24vw;
    height: 24vw;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}

.add_box {
  width: 90vw;
  height: 69vw;
  border-radius: 3vw;
  background: url("~@/assets/img/kuang.png") no-repeat;
  margin: 0 auto;
  background-size: 100%;
  background-position: center;
  padding: 7vw;


  .tishi {
    height: 52vw;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }

  .label {
    font-size: 4vw;
    color: #fff;
    padding: 2vw 0;
  }

  .border {
    display: flex;
    font-size: 4vw;
    color: #fff;
    padding: 1.5vw;
    border: 1px solid #20c595;
    border-radius: 2vw;
    justify-content: space-between;

    .icon {
      font-size: 10vw;
      height: 4vw;
      line-height: 4vw;
    }
  }
}

.link_box {
  display: flex;
  justify-content: space-between;

  .link_item {
    width: 45vw;
  }
}

.tu_box {
  display: flex;
  justify-content: space-between;

  .img {
    width: 32vw;
    height: 32vw;
    transform: rotate(-10deg);

    img {
      width: 100%;
      height: 100%;
      display: block;
    }

  }
}

.link_text {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

/deep/.van-field__control {
  color: #fff !important;
  font-size: 4vw !important;
}

.label_box {
  display: flex;
  justify-content: space-between;
}
</style>